module.exports = __webpack_public_path__ + "img/logo_black.acf9200b.png";